export default __webpack_public_path__ + "static/media/4EUR.42ff343e.png";